import React from 'react';
import styled from 'styled-components';

import { SvgMap } from './SvgMap';

// Compact map preview shown inside RoundResultModal to visualize the distance
// between user's guess and the correct location. Overrides CzechiaSvg's
// min-height (340px) so the map fits comfortably in the modal body.
const Wrap = styled.div`
    margin: 8px auto 4px auto;
    max-width: 100%;
    background: #ffffff;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    overflow: hidden;

    svg {
        min-height: 0 !important;
        max-height: 220px;
        display: block;
    }
`;

const Caption = styled.div`
    text-align: center;
    font-size: 11px;
    color: #8c8c8c;
    padding: 6px 8px;
    border-top: 1px solid #f0f0f0;
    background: #fafafa;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 500;
`;

export const ModalMapPreview = ({ features, guessPoint, targetPoint }) => {
    if (!features || !guessPoint || !targetPoint) return null;
    return (
        <Wrap>
            <SvgMap
                features={features}
                guessPoint={guessPoint}
                targetPoint={targetPoint}
                onMapClick={null}
            />
            <Caption>Tvůj tip (červeně) → správná poloha (zeleně)</Caption>
        </Wrap>
    );
};
